/*
 * @Autor: 杨华
 * @Version: 1.0
 * @Date: 2020-07-10 10:02:05
 * @LastEditors: xx
 * @Description:
 * @LastEditTime: 2020-07-13 19:26:01
 */

import { request } from "./api-require";
import { objAny } from "../common/common-interface";
// const API_URL = "";
//分页查询计费信息---运营商
export const getRatePageList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request("/oms-operation-service/v1/opr/fee/page", data, config);
};
// 查询费率模板信息---运营商
export const getRateInfo = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request("/oms-operation-service/v1/opr/fee/info", data, config);
};
// 查询关联---运营商
export const getBindSta = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    "/oms-operation-service/v1/opr/fee/get_bind_sta",
    data,
    config
  );
};
// 新增费率信息---运营商
export const addRate = (data = {}, config: objAny = {}) => {
  return request("/oms-operation-service/v1/opr/fee/add", data, config);
};
// 修改费率信息---运营商
export const updRate = (data = {}, config: objAny = {}) => {
  return request("/oms-operation-service/v1/opr/fee/upd", data, config);
};
// 删除费率信息---运营商
export const delRate = (data = {}, config: objAny = {}) => {
  config.method = "getDel";
  return request("/oms-operation-service/v1/opr/fee/del", data, config);
};
